export default {
  'profilecredit.profilecreditreport': 'クレジットレポートの割り当て',
  'profilecredit.creditstatus': 'クレジットの状態',
  'profilecredit.credittotalamount': '有効なクレジットの合計額',
  'profilecredit.creditremainamount': 'クレジット残高の合計額',
  'profilecredit.creditamount': 'クレジット額',
  'profilecredit.remaincreditamount': 'クレジット残高　',
  'profilecredit.assigndate': '割り当て日',
  'profilecredit.duration': '日数',
  'profilecredit.active': '有効　',
  'profilecredit.expired': '期限切れ',
  'profilecredit.sum': '合計',
  'profilecredit.expensesamount': '利用額',
  'profilecredit.nocredit': 'クレジットなし',
  'profilecredit.assigncredit': 'クレジット額の決定',
  'profilecredit.creditamountceiling': 'クレジット限度額',
  'profilecredit.deletecredit': 'クレジットの削除',
  'profilecredit.deleteconfirmation': 'クレジットを削除していいですか？',
  'profilecredit.fullname': '姓名',
  'profilecredit.expensesreport': '経費レポート',
  'profilecredit.credit': 'クレジット',
  'profilecredit.mycreditmanagement': 'クレジットの管理',
  'profilecredit.creditmanagement': '与信管理',
  'profilecredit.employeecreditmanagement': '従業員クレジット管理',
  'profilecredit.creditadd': 'クレジットが追加されました',
  'profilecredit.creditadderror':
    'アクティブなクレジットがあります、新しいクレジットを登録することはできません',
  'profilecredit.noteligibleprofile':
    'このプロファイルにクレジットを割り当てることができません',
  'profilecredit.downloadexcel': 'エクセルファイルのダウンロード',
  'profilecredit.fromdate': '割り当て日から',
  'profilecredit.todate': '割り当て日まで',
};
